module.exports = __webpack_public_path__ + "static/img/logo_sokker.61ea820.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/logo_sokker.png
// module id = 1hB7
// module chunks = 2